import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function CallForAbstract() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const importantDates = [
    { event: "Abstract Submission Starts", date: "March 2, 2026" },
      {
        event: "Abstract Submission Deadline",
        oldDate: "March 31, 2026",
        newDate: "April 07, 2026",
        newDate1: "April 15, 2026"
      },
      { event: "Notification to Selected Candidates", date: "June 23, 2026" },
      { event: "Actual Event Date", date: "July 22 – 24, 2026" }
  ];

  return (
    <div className="page-container">
      <PageCarousel />
      
      <section className="section-padding bg-white">
        <div className="container">
          
          {/* 1. Header Section */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="section-title mb-2" style={{ fontWeight: 700, color: '#111' }}>Call for Abstracts</h1>
              <h5 className="text-success font-weight-bold">(Student Research Symposium)</h5>
              <div style={{ width: '80px', height: '4px', background: '#70b60a', margin: '15px auto' }}></div>
              
              <p className="col-lg-10 mx-auto mt-4 text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
                We invite students to participate in the first <strong>Student Research Symposium</strong> at NCVPRIPG 2026. 
                This is a unique platform to showcase your research in computer vision, image processing, pattern recognition, and graphics. 
                The abstract should be concise (max 1500 characters) and will be reviewed by experts.
              </p>
            </div>
          </div>

          {/* 2. Rewards & Eligibility Cards */}
          <div className="row mb-5 justify-content-center">
            <div className="col-lg-5 mb-4">
              <div className="p-4 h-100 rounded shadow-sm border" style={{ background: '#f8f9fa' }}>
                <h5 className="font-weight-bold mb-3" style={{ color: '#70b60a' }}>
                  <i className="lni-star mr-2"></i> Awards & Benefits
                </h5>
                <ul className="list-unstyled">
                  <li className="mb-2"><i className="lni-check-mark-circle text-success mr-2"></i> Best Presentation Awards</li>
                  <li className="mb-2"><i className="lni-check-mark-circle text-success mr-2"></i> Potential Internship Opportunities</li>
                  <li className="mb-2"><i className="lni-check-mark-circle text-success mr-2"></i> Networking with Industry Leaders</li>
                </ul>
              </div>
            </div>
            
            <div className="col-lg-5 mb-4">
              <div className="p-4 h-100 rounded shadow-sm border" style={{ background: '#f8f9fa' }}>
                <h5 className="font-weight-bold mb-3" style={{ color: '#70b60a' }}>
                  <i className="lni-users mr-2"></i> Eligibility
                </h5>
                <p className="small text-muted mb-0">
                  Open to students currently pursuing <strong>Bachelor's, Master's, or Ph.D.</strong> degrees in Engineering and Science. 
                  Your work must align with Computer Vision, Image Processing, or related domains.
                </p>
              </div>
            </div>
          </div>

          {/* 3. Submission CTA */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto text-center">
              <div className="p-5 rounded shadow-sm" style={{ background: '#eef7ff', border: '1px solid #cce5ff' }}>
                <h4 className="font-weight-bold mb-3" style={{ color: '#004085' }}>Ready to Submit?</h4>
                <p className="mb-4">Please note that only submissions via the official Google Form will be considered.</p>
                <a 
                  href="https://forms.gle/YG5Uj2WY1mk7A9p5A" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="btn btn-success btn-lg px-5 py-3"
                  style={{ background: '#70b60a', borderRadius: '50px', fontWeight: '700', boxShadow: '0 4px 15px rgba(0,123,255,0.3)' }}
                >
                  <i className="lni-pencil-alt mr-2"></i> &nbsp; Open Abstract Submission Form
                </a>
              </div>
            </div>
          </div>

          {/* 4. Query & Contact */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto text-center">
              <p className="text-muted">
                Questions? Contact us at: <br />
                <a href="mailto:ncvpripg2026@lnmiit.ac.in" className="font-weight-bold text-dark">
                  ncvpripg2026@lnmiit.ac.in
                </a>
                <br />
                <span className="small">(Please mention <strong>"Student Research Symposium"</strong> in the subject)</span>
              </p>
            </div>
          </div>

          {/* 5. Important Dates Table (Sabse Niche) */}
          <div className="row mt-5">
            <div className="col-lg-10 mx-auto">
              <h3 className="mb-4" style={{ borderLeft: '5px solid #70b60a', paddingLeft: '15px', fontWeight: 600 }}>Important Dates</h3>
              <div className="table-responsive shadow-lg rounded" style={{ overflow: 'hidden' }}>
                <table className="table table-hover mb-0">
                  <thead style={{ background: '#70b60a', color: '#fff' }}>
                    <tr>
                      <th style={{ padding: '18px 25px', fontSize: '16px' }}>Milestone</th>
                      <th style={{ padding: '18px 25px', fontSize: '16px' }}>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importantDates.map((item) => (
                      <tr
                        key={item.event}
                        style={{
                          backgroundColor: item.oldDate ? '#fff3f3' : 'transparent'
                        }}
                      >
                        <td style={{ padding: '15px 25px', fontWeight: '500' }}>
                          {item.event}
                        </td>

                        <td style={{ padding: '15px 25px', fontWeight: '700' }}>
                          {item.oldDate ? (
                            <>
                              {/* Old Date */}
                              <span style={{
                                textDecoration: 'line-through',
                                marginRight: '8px',
                                color: '#777'
                              }}>
                                {item.oldDate}
                              </span>

                              {/* If newDate1 exists → strike newDate also */}
                              {item.newDate1 ? (
                                <>
                                  <span style={{
                                    textDecoration: 'line-through',
                                    marginRight: '8px',
                                    color: '#999'
                                  }}>
                                    {item.newDate}
                                  </span>

                                  <strong style={{ color: 'red' }}>
                                    {item.newDate1}
                                  </strong>
                                </>
                              ) : (
                                <strong style={{ color: 'red' }}>
                                  {item.newDate}
                                </strong>
                              )}
                            </>
                          ) : (
                            item.date
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default CallForAbstract;